import { initReactI18next } from 'react-i18next';

import i18next, { InitOptions } from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

const availableLanguages = ['en', 'es', 'pt-BR'];

const translationOptions: InitOptions = {
  load: 'currentOnly',
  preload: availableLanguages,
  debug: false,
  supportedLngs: availableLanguages,
  fallbackLng: 'pt-BR',
  defaultNS: ['exception'],
  ns: ['exception'],
  react: {
    useSuspense: true,
    bindI18n: 'languageChanged'
  },
  interpolation: {
    escapeValue: false
  },
  backend: {
    loadPath: '/locales/{{lng}}/{{ns}}.json'
  }
};

export default i18next
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init(translationOptions);
